import { useTranslation } from 'next-i18next';
import { formatNumericValue } from 'utils/general';

import { IWarehouseManagement } from '@/modules/warehouseManagement/shared/types';
import IconWithTitleDescription from '@/shared/components/atoms/IconWithTItleDescription';
import { IIconWithTitleDescriptionProps } from '@/shared/components/atoms/IconWithTItleDescription/IconWithTitleDescription';
import { useStore } from '@/shared/hooks/context/createGenericContext';
import { getUnitName } from '@/shared/lib/convert-units';

const CollapsedInput: React.FC<{
  input: IWarehouseManagement.IInboundDeliveryFormProduct;
}> = ({ input }) => {
  const { t } = useTranslation();
  const [selectedAsset] = useStore((store) => store?.asset);

  const items: IIconWithTitleDescriptionProps[] = [
    {
      title: t('no-of-packages'),
      description: formatNumericValue(input.countOfPackages as number),
    },
    {
      title: `${t('package-price')} (${t(selectedAsset?.currency ?? '')})`,
      description: formatNumericValue(input.packagePrice as number),
    },
    {
      title: t('weight-per-package'),
      description: formatNumericValue(input.packageSize as number),
    },
    {
      title: t('measurement-unit'),
      description: t(getUnitName(input.packageUnit ?? undefined)),
    },
    {
      title: t('production-date'),
      description: input.productionDate ?? '-',
    },
    {
      title: t('expiry-date'),
      description: input.expiryDate ?? '-',
    },
  ];

  return (
    <div className='grid grid-cols-2 gap-16 border-t-xs border-t-neutralVariant-90 py-16 px-24'>
      {items.map((item) => (
        <IconWithTitleDescription
          key={item.title}
          item={{
            ...item,
            titleTypography: {
              className: 'text-surface-10',
              variant: 'subtitle2',
            },
          }}
        />
      ))}
    </div>
  );
};

export default CollapsedInput;
